module.exports = __webpack_public_path__ + "img/brown.6e74c0ec.jpg";